import * as actions from "../action.constants";

const requestInventory = (pageUrl) => ({
  type: actions.REQUEST_INVENTORY_LIST_SAGA,
  pageUrl,
});

const addInventory = (requestPayload, callback) => ({
  type: actions.REQUEST_ADD_INVENTORY_SAGA,
  requestPayload,
  callback,
});

const deleteInventoryData = (id, callback) => ({
  type: actions.REQUEST_DELETE_INVENTORY_SAGA,
  payload: id,
  callback,
});

const suspendInventorySim = (id, callback) => ({
  type: actions.REQUEST_SUSPEND_INVENTORY_SIM_SAGA,
  payload: id,
  callback,
});

const toggleInventoryCommission = (mac, callback) => ({
  type: actions.REQUEST_TOGGLE_INVENTORY_COMMISSION_SAGA,
  payload: mac,
  callback,
});

const systemProfile = (requestPayload) => ({
  type: actions.REQUEST_SYSTEM_PROFILE_DATA,
  requestPayload,
});

const simDropdown = (requestPayload) => ({
  type: actions.REQUEST_SIM_DROPDOWN_DATA,
  requestPayload,
});

const storeEditInventoryData = (requestPayload) => ({
  type: actions.STORE_EDIT_INVENTORY_DATA,
  requestPayload,
});

const storeInventory = (responsePayload) => ({
  type: actions.SAVE_INVENTORY_LIST,
  responsePayload,
});

export {
  requestInventory,
  addInventory,
  suspendInventorySim,
  toggleInventoryCommission,
  simDropdown,
  systemProfile,
  deleteInventoryData,
  storeEditInventoryData,
  storeInventory,
};
